// 日历 (src/office/calendar.ts, src/routes/calendar.ts): booked meetings. 「日历」 in the top bar opens the calendar: a
// week (or day) of meetings on an hour grid, a list on a phone; 只看我的 / 全部 (everyone's room bookings, so a free
// room is easy to find; someone else's meeting shows its title, time, room and who booked it, not its agenda or
// invitees). 约会议 books one: 名称, 日期 and 时间 (in this device's time zone; a weekly meeting keeps that wall-clock
// time), 时长, 地点 (a 会议室 on any floor), 每周重复 (how many times), 邀请 (members and agents who have been aboard),
// 议程, 建议记录会议纪要. A clash with another booking of the room is refused, naming it. A meeting's card: when, where,
// who (with their answers), the agenda; 去会议室 (walks there, changing floor first if needed), 参加 / 不参加, and for the
// one who booked it 修改 / 取消这次 / 取消会议.
// The office tells me ({t:"cal"}): an invite (a card: 查看 / 不参加), a change or a cancellation (a toast), 10 minutes
// before and at the start (a card with a chime: 去会议室). At the start of a meeting booked with 会议纪要, whoever is in
// its room is offered 开始记录 (recording never starts by itself).
// Everything shown is set as text (titles, names and agendas come from other people).
import { icon, label, put } from '/icons.js';
import { dropdown } from '/dropdown.js';
import { t, tParts, tr, onLang, errorText, lang } from '/i18n.js';
import { boatName } from '/floors.js';

const el = (tag, cls, text) => { const e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; };
const CSS = `
#calBtn{order:1;box-sizing:border-box;height:30px;background:#fff8e7;border:2px solid #1b1410;border-radius:10px;padding:4px 10px;font:12px/1.5 var(--ui-font,-apple-system,system-ui,sans-serif);color:#1b1410;cursor:pointer;display:inline-flex;align-items:center;gap:5px;white-space:nowrap}
#calBtn.on{background:#FDD03B} #calBtn .nx{color:#6b5a44} #calBtn.soon .nx{color:#b91c1c;font-weight:600}
#calDlg{position:fixed;inset:0;z-index:88;display:flex;align-items:center;justify-content:center;background:rgba(20,40,60,.55);padding:calc(12px + var(--st,0px)) calc(12px + var(--sr,0px)) calc(12px + var(--sb,0px)) calc(12px + var(--sl,0px));box-sizing:border-box}
#calDlg .cc{position:relative;display:flex;flex-direction:column;width:900px;max-width:100%;height:min(680px,100%);background:#fff8e7;border:3px solid #1b1410;border-radius:16px;box-shadow:0 5px 0 #1b1410;font:14px/1.5 var(--ui-font,-apple-system,system-ui,sans-serif);color:#1b1410;overflow:hidden}
#calDlg .hd{display:flex;align-items:center;gap:8px;flex-wrap:wrap;padding:10px 14px;border-bottom:2px solid #e3d3b0}
#calDlg .hd h3{margin:0;font-size:16px;display:flex;align-items:center;gap:6px}
#calDlg .hd .rng{font-weight:600;min-width:0}
#calDlg .sp{flex:1}
#calDlg .b{font:inherit;font-size:13px;border:2px solid #1b1410;border-radius:999px;padding:3px 12px;background:#fff;cursor:pointer;white-space:nowrap;display:inline-flex;align-items:center;gap:4px;color:#1b1410}
#calDlg .b.main{background:#FDD03B;font-weight:600}
#calDlg .b.warn{background:#fee2e2}
#calDlg .b:disabled{opacity:.5;cursor:default}
#calDlg button.x{font:inherit;border:2px solid #1b1410;border-radius:999px;background:#fff;cursor:pointer;width:28px;height:28px;padding:0;display:inline-flex;align-items:center;justify-content:center}
#calDlg .seg{display:inline-flex;border:2px solid #1b1410;border-radius:999px;overflow:hidden}
#calDlg .seg button{font:inherit;font-size:13px;border:0;background:#fff;padding:3px 10px;cursor:pointer;color:#1b1410}
#calDlg .seg button.on{background:#FDD03B;font-weight:600}
#calDlg .bd{flex:1;min-height:0;overflow:auto;position:relative}
#calDlg .grid{display:grid;position:relative;min-width:560px}
#calDlg .grid .dh{position:sticky;top:0;z-index:2;background:#fff8e7;border-bottom:2px solid #e3d3b0;text-align:center;font-size:12px;padding:4px 0;font-weight:600}
#calDlg .grid .dh.today{color:#b45309} #calDlg .grid .dh.today b{background:#FDD03B;border-radius:6px;padding:0 4px}
#calDlg .grid .hr{font-size:11px;color:#8a7f72;text-align:right;padding-right:6px;transform:translateY(-7px)}
#calDlg .grid .col{position:relative;border-left:1px solid #e9dcc0}
#calDlg .grid .col .ln{position:absolute;left:0;right:0;border-top:1px solid #f0e4c9}
#calDlg .grid .col.today{background:rgba(253,208,59,.08)}
#calDlg .grid .now{position:absolute;left:0;right:0;border-top:2px solid #ef4444;z-index:1}
#calDlg .ev{position:absolute;box-sizing:border-box;border:2px solid #1b1410;border-radius:8px;padding:2px 5px;font-size:12px;line-height:1.3;overflow:hidden;cursor:pointer;background:#dbeafe;text-align:left;font-family:inherit;color:#1b1410}
#calDlg .ev.mine{background:#FDD03B} #calDlg .ev.other{background:#efe7d6;border-color:#a89b86;color:#5b5243} #calDlg .ev.no{opacity:.55;text-decoration:line-through}
#calDlg .ev b{display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap} #calDlg .ev span{display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
#calDlg .list{padding:8px 14px 16px}
#calDlg .list h4{margin:12px 0 4px;font-size:13px;color:#6b5a44} #calDlg .list h4.today{color:#b45309}
#calDlg .list .it{display:flex;gap:10px;align-items:flex-start;width:100%;text-align:left;font:inherit;border:2px solid #1b1410;border-radius:10px;background:#fff;padding:6px 10px;margin:4px 0;cursor:pointer;color:#1b1410}
#calDlg .list .it.mine{background:#fff3c4} #calDlg .list .it.other{background:#f6f0e3;border-color:#a89b86} #calDlg .list .it.no{opacity:.6}
#calDlg .list .it .tm{font-weight:600;white-space:nowrap;min-width:92px} #calDlg .list .it .tt{min-width:0;flex:1} #calDlg .list .it .tt b{display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap} #calDlg .list .it .tt span{font-size:12px;color:#6b5a44}
#calDlg .empty{color:#8a7f72;text-align:center;padding:28px 10px}
#calDlg .form,#calDlg .one{padding:12px 16px 18px;max-width:560px;margin:0 auto}
#calDlg label.f{display:block;font-size:12px;font-weight:600;margin:10px 0 3px}
#calDlg input[type=text],#calDlg input[type=date],#calDlg input[type=time],#calDlg input[type=number],#calDlg textarea{font:inherit;box-sizing:border-box;border:2px solid #1b1410;border-radius:8px;padding:5px 8px;background:#fff;color:#1b1410}
#calDlg input[type=text],#calDlg textarea{width:100%} #calDlg textarea{min-height:80px;resize:vertical}
#calDlg .row{display:flex;gap:8px;flex-wrap:wrap;align-items:center}
#calDlg .ck{display:flex;gap:6px;align-items:center;font-size:13px;margin:10px 0 0;cursor:pointer}
#calDlg .ck input{width:18px;height:18px;accent-color:#1b1410;margin:0}
#calDlg .chips{display:flex;gap:6px;flex-wrap:wrap;margin:4px 0}
#calDlg .chip{display:inline-flex;align-items:center;gap:4px;border:2px solid #1b1410;border-radius:999px;padding:0 4px 0 8px;font-size:12px;background:#fff}
#calDlg .chip button{border:0;background:none;cursor:pointer;padding:0;display:inline-flex}
#calDlg .who{border:2px solid #1b1410;border-radius:10px;background:#fff;max-height:180px;overflow:auto;margin-top:4px}
#calDlg .who .p{display:flex;align-items:center;gap:8px;padding:4px 8px;cursor:pointer;font-size:13px}
#calDlg .who .p:hover{background:#f4e6c6} #calDlg .who .p input{width:16px;height:16px;accent-color:#1b1410;margin:0}
#calDlg .who .none{padding:8px;color:#8a7f72;font-size:12px}
#calDlg .note{font-size:12px;color:#6b5a44;margin:4px 0}
#calDlg .err{color:#b91c1c;font-size:13px;min-height:1.2em;margin:8px 0 0}
#calDlg .one h2{font-size:18px;margin:4px 0 6px;word-break:break-word}
#calDlg .one .kv{display:grid;grid-template-columns:64px 1fr;gap:4px 10px;font-size:13px;margin:8px 0}
#calDlg .one .kv .k{color:#6b5a44}
#calDlg .one .ag{white-space:pre-wrap;word-break:break-word;background:#fff;border:2px dashed #c9b994;border-radius:10px;padding:8px 10px;font-size:13px}
#calDlg .one .acts{display:flex;gap:8px;flex-wrap:wrap;margin:14px 0 0}
#calDlg .one .ppl{display:flex;flex-wrap:wrap;gap:4px} #calDlg .one .ppl span{border:1px solid #c9b994;border-radius:999px;padding:0 8px;font-size:12px;background:#fff}
#calDlg .one .ppl span.yes{background:#dcfce7;border-color:#15803d} #calDlg .one .ppl span.no{background:#f3f0ea;color:#999;text-decoration:line-through}
/* settings, Calendar section (outside the dialog): the same buttons and fields */
.calset .b{font:inherit;font-size:13px;border:2px solid #1b1410;border-radius:999px;padding:3px 12px;background:#fff;cursor:pointer;white-space:nowrap;display:inline-flex;align-items:center;gap:4px;color:#1b1410;text-decoration:none}
.calset .b.main{background:#FDD03B;font-weight:600} .calset .b.warn{background:#fee2e2} .calset .b:disabled{opacity:.5;cursor:default}
.calset .row{display:flex;gap:8px;flex-wrap:wrap;align-items:center;margin:6px 0} .calset .note{font-size:12px;color:#6b5a44;margin:4px 0} .calset .err{color:#b91c1c;font-size:13px}
.calset input[type=text]{font:inherit;font-size:12px;box-sizing:border-box;border:2px solid #1b1410;border-radius:8px;padding:4px 8px;background:#fff;min-width:0;flex:1}
@media (max-width:640px){
 #calDlg{padding:calc(6px + var(--st,0px)) 0 0;align-items:flex-end}
 #calDlg .cc{height:100%;border-radius:16px 16px 0 0;border-bottom:0}
 #calDlg .hd{padding:8px 10px;gap:6px} #calDlg .hd .seg.view{display:none}
 #calBtn{padding:4px 7px} #calBtn .nx{display:none}
}`;

const DAY = 24 * 3600_000, MIN = 60_000;
const TZ = (() => { try { return Intl.DateTimeFormat().resolvedOptions().timeZone || 'Asia/Shanghai'; } catch { return 'Asia/Shanghai'; } })();
const pad = (n) => String(n).padStart(2, '0');
const hm = (t) => { const d = new Date(t); return `${pad(d.getHours())}:${pad(d.getMinutes())}`; };
const md = (ts) => { const d = new Date(ts); return t('cal.date.md', { mo: d.getMonth() + 1, d: d.getDate() }); };
const dayName = (ts) => { const d = new Date(ts); return t('cal.date.day', { mo: d.getMonth() + 1, d: d.getDate(), wd: String(d.getDay()) }); };
const dayStart = (t) => { const d = new Date(t); d.setHours(0, 0, 0, 0); return d.getTime(); };
const addDays = (t, n) => { const d = new Date(t); d.setDate(d.getDate() + n); return d.getTime(); };
const weekStart = (t) => { const d = new Date(dayStart(t)); const wd = (d.getDay() + 6) % 7; d.setDate(d.getDate() - wd); return d.getTime(); };
const durText = (m) => (m < 60 ? t('cal.dur.min', { m }) : m % 60 ? t('cal.dur.hm', { h: Math.floor(m / 60), m: m % 60 }) : t('cal.dur.h', { h: m / 60 }));
// a room's boat as the boat menu names it (Deck, 2 号船, 活动舱: public/floors.js), from the name the office keeps ('1F')
const boatOf = (p) => boatName({ id: p.floor, name: p.floorName, kind: /-play$/.test(p.floorRoom ?? '') ? 'play' : undefined });
const placeText = (p) => (p?.kind === 'call' ? t('cal.place.call') : p ? `${boatOf(p)} · ${p.zoneName}` : '');
/** In another time zone than the meeting's: also say when it is there (artin is in Asia/Shanghai). */
function tzNote(m, ts) {
  if (!m.tz || m.tz === TZ) return '';
  try { return t('cal.tzNote', { tz: m.tz, time: new Date(ts).toLocaleString(lang, { timeZone: m.tz, month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false }) }); } catch { return ''; }
}
/** The codes this page words itself whatever the server's message says (cal.err.<code>); E_INVALID by its reason
 *  (cal.err.E_INVALID.<reason>, with params), E_CONFLICT with the meeting it clashes with. */
const OWN_ERR = /^E_(GUEST_|STORAGE|NO_MEETING|CHANGED$|PAST$|RATE$|FORBIDDEN$|NOT_FOUND$|MOVED$|FULL$|NET$)/;
function whyOf(j) {
  const code = j?.code ?? '';
  if (code === 'E_CONFLICT' && j.conflict) return t('cal.err.E_CONFLICT', { title: j.conflict.title, day: dayName(j.conflict.at), time: hm(j.conflict.at), by: j.conflict.by });
  if (code === 'E_INVALID' && typeof j.reason === 'string') return errorText('cal.err.E_INVALID', { ...j, code: j.reason });
  if (OWN_ERR.test(code)) return errorText('cal.err', j);
  return j?.message || t('cal.err.other');
}

/** The view switch and 只看我的 / 全部, and the answer buttons: text keys by state (as the bar, toolbar.js). */
const VIEWS = { day: 'cal.view.day', week: 'cal.view.week', list: 'cal.view.list' };
const WHO = { mine: { text: 'cal.who.mineOnly', title: 'cal.who.mineOnlyTitle' }, all: { text: 'cal.who.all', title: 'cal.who.allTitle' } };
const RSVP = { yes: { icon: 'check', text: 'cal.rsvp.yes', every: 'cal.rsvp.yesAll' }, no: { icon: 'close', text: 'cal.rsvp.no', every: 'cal.rsvp.noAll' } };

/** Walk to a meeting's room: on this floor, or on another one (the page goes there; the walk is kept in sessionStorage
 *  for the new page). */
function goToRoom(o, p, rec = null) {
  if (p?.kind !== 'room') return;
  if (p.floor === (o.floor?.id ?? 1)) { o.members.whenFree(() => o.members.walkToZone(p.zone, p.zoneName), 'cal-go'); return; }
  try { sessionStorage.setItem('cal.go', JSON.stringify({ floor: p.floor, zone: p.zone, name: p.zoneName, until: Date.now() + 2 * MIN, ...(rec ? { rec } : {}) })); } catch {}
  // floors.js's own switch: it asks about an unsaved map draft and stops voice, sharing and the socket first
  if (o.floor?.go) { if (!o.floor.go(p.floor)) o.toast(t('cal.floorGone')); return; }
  if (o.canLeave && !o.canLeave()) return;
  const u = new URL(location.href); u.searchParams.set('floor', String(p.floor)); location.assign(u);
}
/** After 去会议室 changed the floor: walk there; `rec(zone, {title, until})`: the 开始记录 offer it carried. */
function pendingGo(o, rec) {
  let g = null; try { g = JSON.parse(sessionStorage.getItem('cal.go') || 'null'); sessionStorage.removeItem('cal.go'); } catch {}
  if (g && g.until > Date.now() && g.floor === (o.floor?.id ?? 1) && typeof g.zone === 'string') {
    if (rec && g.rec && g.rec.until > Date.now()) rec(g.zone, { title: String(g.rec.title ?? ''), until: g.rec.until });
    o.members.whenFree(() => o.members.walkToZone(g.zone, String(g.name ?? '')), 'cal-go');
  }
}
/** A guest (访客) who came through a meeting's guest link: no calendar, only that meeting: a card when aboard (查看 /
 *  去会议室), and again 10 minutes before and at the start (timers on this page: the office doesn't send guests
 *  reminders). */
function guestMode(o) {
  const timers = [];
  async function load() {
    for (const tm of timers.splice(0)) clearTimeout(tm);
    const r = await fetch('/api/cal/guest', { cache: 'no-store' }).catch(() => null), j = r?.ok ? await r.json().catch(() => null) : null;
    for (const m of j?.meetings ?? []) {
      const end = m.start + m.dur * MIN, room = m.place?.kind === 'room';
      const show = (phase) => {
        const now = Date.now(); if (end <= now) return;
        const at = { title: m.title, place: placeText(m.place) };
        const text = phase === 'now' || m.start <= now ? t('cal.card.now', at) : phase === 'soon' ? t('cal.card.soon', at)
          : t('cal.guest.invited', { ...at, name: m.by.name, when: `${dayName(m.start)} ${hm(m.start)}${tzNote(m, m.start)}` });
        o.members.addCard({ id: `calg:${m.id}:${phase}`, prio: phase === 'hello' ? 0 : 1, icon: 'timer', text, expires: phase === 'hello' ? Math.min(end, now + 10 * MIN) : phase === 'soon' ? m.start : Math.min(end, m.start + 15 * MIN),
          yes: t(room ? 'cal.card.go' : 'cal.card.ok'), yesIcon: room ? 'door' : 'check', yesTitle: room ? t('cal.card.goTitle') : '', no: t('cal.card.close'), noIcon: 'close',
          left: () => (m.start <= now ? t('cal.card.on') : t('cal.card.startsAt', { when: `${md(m.start)} ${hm(m.start)}` })), accept: () => { if (room) goToRoom(o, m.place); }, decline: () => {} });
      };
      show('hello');
      const now = Date.now();
      if (m.start - 10 * MIN > now) timers.push(setTimeout(() => show('soon'), m.start - 10 * MIN - now));
      if (m.start > now) timers.push(setTimeout(() => show('now'), m.start - now));
    }
  }
  return { msg() {}, welcome() { load(); pendingGo(o); }, entered() {}, roomSchedule: () => null, roomTag: () => null };
}

/**
 * @param o {floor: {id, name, room}, me(), peers(), toast(text, go?, icon?, goText?), members (public/members.js: addCard,
 *   dropCard, whenFree, walkToZone), notes (public/notes.js), room(): the 会议室 I'm in (zone id) or null, canLeave(): may
 *   this page go to another floor now, guest: true for a guest (no calendar)}
 */
export function initCalendar(o) {
  if (o.guest) return guestMode(o);
  if (!document.getElementById('cal-css')) { const s = el('style'); s.id = 'cal-css'; s.textContent = CSS; document.head.append(s); }
  const btn = el('button'); btn.id = 'calBtn'; btn.type = 'button';
  const nx = el('span', 'nx');
  btn.append(icon('timer'), tr(el('span'), 'cal.bar.text'), nx);
  tr(btn, null, null, { title: 'cal.bar.title' });
  document.getElementById('topleft')?.append(btn);
  btn.onclick = () => (dlg ? close() : showCal());

  let dlg = null, mode = innerWidth <= 640 ? 'list' : 'week', anchor = Date.now(), onlyMine = false;
  let cache = [], rooms = null, people = null;
  const api = async (path, body) => {
    const r = await fetch(path, body ? { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) } : { cache: 'no-store' }).catch(() => null);
    const j = r ? await r.json().catch(() => null) : null;
    if (!r || !r.ok) return { ok: false, ...(j?.error ?? { code: 'E_NET', message: 'network trouble' }) };
    return j;
  };

  // ---- the next meeting of mine today, on the button
  let upcoming = [];
  async function refreshNext() {
    const now = Date.now(), j = await api(`/api/cal/meetings?mine=1&from=${now - 3 * 3600_000}&to=${now + DAY}`);
    if (!j.ok) return;
    upcoming = [];
    for (const m of j.meetings) for (const s of m.occ) if (s + m.dur * MIN > now && m.rsvp !== 'no') upcoming.push({ m, s });
    upcoming.sort((a, b) => a.s - b.s);
    paintNext();
  }
  function paintNext() {
    const now = Date.now(), n = upcoming.find((u) => u.s + u.m.dur * MIN > now);
    btn.classList.toggle('soon', !!n && n.s - now < 15 * MIN);
    nx.textContent = !n ? '' : n.s <= now ? t('cal.bar.on', { title: n.m.title }) : dayStart(n.s) === dayStart(now) ? `· ${hm(n.s)} ${n.m.title}` : '';
    if (nx.textContent.length > 22) nx.textContent = nx.textContent.slice(0, 21) + '…';
  }
  setInterval(paintNext, 30_000);
  setInterval(refreshNext, 10 * MIN);

  // ---- the 会议室 bookings today on this floor, for the room card (public/pick.js)
  let today = [], todayAt = 0;
  async function refreshToday() {
    const a = dayStart(Date.now()), j = await api(`/api/cal/meetings?from=${a}&to=${addDays(a, 1)}`);
    if (!j.ok) return;
    const here = o.floor?.id ?? 1;
    today = [];
    for (const m of j.meetings) if (m.place.kind === 'room' && m.place.floor === here) for (const s of m.occ) today.push({ m, s });
    today.sort((x, y) => x.s - y.s); todayAt = Date.now(); tagsAt = 0;
  }
  setInterval(() => { if (Date.now() - todayAt > 5 * MIN) refreshToday(); }, 60_000);
  /** The plaque's words for a room (asked every frame: worked out every 15 s): 会议中 while a meeting is on, 「15:00 有会」
   *  when one starts within the hour. */
  let tags = new Map(), tagsAt = 0;
  function roomTag(zone) {
    const now = Date.now();
    if (now - tagsAt > 15_000) {
      tagsAt = now; tags = new Map(); const ON_TAG = t('cal.tag.on');
      for (const { m, s } of today) {
        const z = m.place.zone, end = s + m.dur * MIN;
        if (s <= now && end > now) tags.set(z, ON_TAG);
        else if (s > now && s - now <= 60 * MIN && !tags.has(z)) tags.set(z, t('cal.tag.at', { time: hm(s) }));
      }
    }
    return tags.get(zone) ?? null;
  }
  /** A 会议室's card: what's on now and later today, and 约这个会议室. */
  function roomSchedule(zone) {
    if (Date.now() - Math.max(todayAt, roomSchedule.tried ?? 0) > 60_000) { roomSchedule.tried = Date.now(); refreshToday(); } // a card opened: fresh within the minute
    const now = Date.now(), list = today.filter((x) => x.m.place.zone === zone && x.s + x.m.dur * MIN > now);
    const lines = list.slice(0, 3).map(({ m, s }) => {
      const on = s <= now;
      return { now: on, text: t('cal.room.line', { on: on ? 'yes' : 'no', from: hm(s), to: hm(s + m.dur * MIN), title: m.title, who: m.mine ? t(m.owner ? 'cal.who.mine' : 'cal.who.invitedMe') : m.by.name }) };
    });
    if (list.length > 3) lines.push({ text: t('cal.room.more', { n: list.length - 3 }) });
    if (!lines.length) lines.push({ text: t('cal.room.none') });
    return { lines, book: () => showForm(null, undefined, `${o.floor?.id ?? 1}:${zone}`) };
  }

  // ---- the dialog
  function close() { dlg?.remove(); dlg = null; btn.classList.remove('on'); removeEventListener('keydown', esc, true); }
  function esc(e) { if (e.key === 'Escape' && dlg) { e.stopImmediatePropagation(); if (dlg.dataset.view !== 'cal') showCal(); else close(); } }
  function shell() {
    if (dlg) return dlg;
    dlg = el('div'); dlg.id = 'calDlg'; dlg.setAttribute('role', 'dialog'); dlg.setAttribute('aria-label', t('cal.title'));
    const cc = el('div', 'cc'); dlg.append(cc);
    dlg.addEventListener('pointerdown', (e) => { if (e.target === dlg) close(); });
    dlg.addEventListener('keydown', (e) => e.stopPropagation()); // typing here never walks the otter
    addEventListener('keydown', esc, true);
    document.body.append(dlg); btn.classList.add('on');
    return dlg;
  }
  const cc = () => dlg.querySelector('.cc');
  function head(title, ic, back) {
    const h = el('div', 'hd'), h3 = put(el('h3'), ic, title);
    if (back) { const b = el('button', 'b'); label(b, 'undo', t('cal.back')); b.type = 'button'; b.onclick = back; h.append(b); }
    h.append(h3);
    return h;
  }
  const xBtn = () => { const x = el('button', 'x'); x.type = 'button'; x.title = t('cal.close'); x.append(icon('close')); x.onclick = close; return x; };

  function range() {
    if (mode === 'week') { const a = weekStart(anchor); return [a, addDays(a, 7)]; }
    if (mode === 'day') { const a = dayStart(anchor); return [a, addDays(a, 1)]; }
    const a = dayStart(anchor); return [a, addDays(a, 14)];
  }
  async function showCal() {
    shell(); dlg.dataset.view = 'cal';
    const h = head(t('cal.title'), 'timer');
    const [a, b] = range();
    const rng = el('span', 'rng', mode === 'day' ? dayName(a) : `${md(a)} – ${md(b - 1)}`);
    const prev = el('button', 'b', '‹'); prev.title = t('cal.prev'); prev.type = 'button';
    const next = el('button', 'b', '›'); next.title = t('cal.next'); next.type = 'button';
    const step = mode === 'week' ? 7 : mode === 'day' ? 1 : 14;
    prev.onclick = () => { anchor = addDays(anchor, -step); showCal(); };
    next.onclick = () => { anchor = addDays(anchor, step); showCal(); };
    const todayB = el('button', 'b', t('cal.today')); todayB.type = 'button'; todayB.onclick = () => { anchor = Date.now(); showCal(); };
    const views = el('div', 'seg view');
    for (const [v, key] of Object.entries(VIEWS)) { const x = el('button', mode === v ? 'on' : '', t(key)); x.type = 'button'; x.onclick = () => { mode = v; showCal(); }; views.append(x); }
    const who = el('div', 'seg');
    for (const [v, w] of [[true, WHO.mine], [false, WHO.all]]) { const x = el('button', onlyMine === v ? 'on' : '', t(w.text)); x.type = 'button'; x.title = t(w.title); x.onclick = () => { onlyMine = v; showCal(); }; who.append(x); }
    const book = el('button', 'b main'); label(book, 'pencil', t('cal.book')); book.type = 'button'; book.onclick = () => showForm(null);
    const sub = el('button', 'b'); label(sub, 'download', t('cal.sub')); sub.type = 'button'; sub.title = t('cal.subTitle'); sub.onclick = () => showFeed();
    h.append(prev, todayB, next, rng, el('span', 'sp'), views, who, sub, book, xBtn());
    const bd = el('div', 'bd'); bd.append(el('div', 'empty', t('cal.loading')));
    cc().replaceChildren(h, bd);
    const j = await api(`/api/cal/meetings?from=${a}&to=${b}${onlyMine ? '&mine=1' : ''}`);
    if (!dlg || dlg.dataset.view !== 'cal' || !bd.isConnected) return;
    if (!j.ok) { bd.replaceChildren(el('div', 'empty', whyOf(j))); return; }
    cache = j.meetings;
    if (mode === 'list') bd.replaceChildren(listView(a, b, j.meetings));
    else { bd.replaceChildren(gridView(a, mode === 'week' ? 7 : 1, j.meetings)); const g = bd.querySelector('.grid'); bd.scrollTop = Math.max(0, (g?.dataset.scroll ?? 0) - 8); }
  }
  const evCls = (m) => (m.mine ? (m.owner ? 'mine' : '') : 'other') + (m.rsvp === 'no' ? ' no' : '');
  function listView(a, b, ms) {
    const box = el('div', 'list'), occ = [];
    for (const m of ms) for (const s of m.occ) if (s >= a - m.dur * MIN && s < b) occ.push({ m, s });
    occ.sort((x, y) => x.s - y.s);
    if (!occ.length) { box.append(el('div', 'empty', t(onlyMine ? 'cal.list.emptyMine' : 'cal.list.empty'))); return box; }
    let day = null;
    for (const { m, s } of occ) {
      const d = dayStart(s);
      if (d !== day) { day = d; box.append(el('h4', d === dayStart(Date.now()) ? 'today' : '', d === dayStart(Date.now()) ? t('cal.list.today', { day: dayName(s) }) : dayName(s))); }
      const it = el('button', 'it ' + evCls(m)); it.type = 'button';
      const tt = el('div', 'tt'); tt.append(el('b', '', m.title), el('span', '', t('cal.list.sub', { place: placeText(m.place), by: m.mine && m.owner ? t('cal.who.mine') : t('cal.who.by', { name: m.by.name }), weekly: m.count > 1 ? 'yes' : 'no' })));
      it.append(el('span', 'tm', `${hm(s)}–${hm(s + m.dur * MIN)}`), tt);
      it.onclick = () => showOne(m, s);
      box.append(it);
    }
    return box;
  }
  function gridView(a, days, ms) {
    const HH = 56; // px per hour
    let h0 = 8, h1 = 21;
    const occ = [];
    for (const m of ms) for (const s of m.occ) {
      const e = s + m.dur * MIN;
      for (let k = 0; k < days; k++) {
        const d0 = addDays(a, k), d1 = addDays(a, k + 1);
        if (s < d1 && e > d0) { const from = Math.max(s, d0), to = Math.min(e, d1); occ.push({ m, s, k, from, to }); h0 = Math.min(h0, new Date(from).getHours()); h1 = Math.max(h1, Math.ceil((to - d0) / 3600_000)); }
      }
    }
    h1 = Math.min(24, h1);
    const g = el('div', 'grid'); g.style.gridTemplateColumns = `44px repeat(${days}, 1fr)`;
    g.append(el('div', 'dh', ''));
    const today = dayStart(Date.now());
    for (let k = 0; k < days; k++) { const d = addDays(a, k), x = el('div', 'dh' + (d === today ? ' today' : '')); x.append(el('b', '', t('cal.date.col', { wd: String(new Date(d).getDay()), d: new Date(d).getDate() }))); g.append(x); }
    const hrs = el('div'); hrs.style.position = 'relative'; hrs.style.height = `${(h1 - h0) * HH}px`;
    for (let h = h0; h < h1; h++) { const x = el('div', 'hr', `${pad(h)}:00`); x.style.position = 'absolute'; x.style.top = `${(h - h0) * HH}px`; x.style.right = '0'; hrs.append(x); }
    g.append(hrs);
    const cols = [];
    for (let k = 0; k < days; k++) {
      const d = addDays(a, k), c = el('div', 'col' + (d === today ? ' today' : '')); c.style.height = `${(h1 - h0) * HH}px`;
      for (let h = h0; h < h1; h++) { const l = el('div', 'ln'); l.style.top = `${(h - h0) * HH}px`; c.append(l); }
      if (d === today) { const n = el('div', 'now'); n.style.top = `${((Date.now() - d) / 3600_000 - h0) * HH}px`; c.append(n); }
      // a click on an empty hour books from there
      c.addEventListener('dblclick', (e) => { if (e.target !== c && !e.target.classList.contains('ln')) return; const y = e.offsetY + (e.target === c ? 0 : e.target.offsetTop); const at = d + (h0 + Math.floor(y / (HH / 2)) / 2) * 3600_000; showForm(null, at); });
      cols.push(c); g.append(c);
    }
    // side by side when they overlap (lanes, per day)
    for (let k = 0; k < days; k++) {
      const day = occ.filter((x) => x.k === k).sort((x, y) => x.from - y.from || y.to - x.to), lanes = [];
      for (const x of day) { let i = lanes.findIndex((end) => end <= x.from); if (i < 0) { i = lanes.length; lanes.push(0); } lanes[i] = x.to; x.lane = i; }
      for (const x of day) {
        const n = Math.max(1, ...day.filter((y) => y.from < x.to && x.from < y.to).map((y) => y.lane + 1));
        const d0 = addDays(a, k), top = ((x.from - d0) / 3600_000 - h0) * HH, ht = Math.max(18, ((x.to - x.from) / 3600_000) * HH - 2);
        const b = el('button', 'ev ' + evCls(x.m)); b.type = 'button';
        b.style.top = `${top}px`; b.style.height = `${ht}px`; b.style.left = `calc(${(100 * x.lane) / n}% + 2px)`; b.style.width = `calc(${100 / n}% - 4px)`;
        b.append(el('b', '', x.m.title)); if (ht >= 36) b.append(el('span', '', `${hm(x.s)} ${placeText(x.m.place)}`));
        b.title = t('cal.grid.tip', { title: x.m.title, from: hm(x.s), to: hm(x.s + x.m.dur * MIN), place: placeText(x.m.place), name: x.m.by.name });
        b.onclick = () => showOne(x.m, x.s);
        cols[k].append(b);
      }
    }
    const first = occ.length ? Math.min(...occ.map((x) => ((x.from - addDays(a, x.k)) / 3600_000 - h0) * HH)) : (9 - h0) * HH;
    g.dataset.scroll = String(Math.max(0, first));
    return g;
  }

  // ---- one meeting
  let shownOne = null;
  async function showOne(m, s) {
    shell(); dlg.dataset.view = 'one'; shownOne = [m, s];
    const h = head(t('cal.one.title'), 'note', () => showCal()); h.append(el('span', 'sp'), xBtn());
    const one = el('div', 'one'), bd = el('div', 'bd'); bd.append(one);
    cc().replaceChildren(h, bd);
    one.append(el('h2', '', m.title));
    const kv = el('div', 'kv');
    const add = (k, v) => { kv.append(el('span', 'k', k)); if (typeof v === 'string') kv.append(el('span', '', v)); else kv.append(v); };
    add(t('cal.one.when'), t('cal.one.time', { day: dayName(s), from: hm(s), to: hm(s + m.dur * MIN), dur: durText(m.dur) }) + tzNote(m, s));
    if (m.count > 1) add(t('cal.one.repeat'), t('cal.one.weekly', { count: m.count, skipped: m.skip?.length ?? 0 }));
    add(t('cal.where'), placeText(m.place));
    add(t('cal.one.by'), m.owner ? t('cal.one.byMe', { name: m.by.name }) : m.by.name);
    if (m.invitees) {
      const ppl = el('div', 'ppl');
      if (!m.invitees.length) ppl.append(el('span', '', t('cal.one.nobody')));
      for (const i of m.invitees) { const x = el('span', i.rsvp ?? '', t('cal.one.invitee', { name: i.name, agent: i.kind === 'agent' ? 'yes' : 'no', rsvp: i.rsvp ?? 'none' })); ppl.append(x); }
      add(t('cal.one.people'), ppl);
    }
    if (m.record) add(t('cal.one.notes'), t('cal.one.notesOn'));
    if (m.guest) add(t('cal.one.guests'), t('cal.one.guestsUntil', { when: `${dayName(m.guest.exp)} ${hm(m.guest.exp)}` }));
    one.append(kv);
    if (m.agenda) { one.append(el('label', 'f', t('cal.agenda')), el('div', 'ag', m.agenda)); }
    if (!m.mine) one.append(el('p', 'note', t('cal.one.others')));
    const err = el('p', 'err'), acts = el('div', 'acts');
    const end = s + m.dur * MIN, live = end > Date.now();
    const inIt = m.place.kind === 'room' && m.place.floor === (o.floor?.id ?? 1) && o.room?.() === m.place.zone;
    if (m.place.kind === 'call' && live && m.mine && o.call && s <= Date.now() + 15 * MIN) { const g = el('button', 'b main'); label(g, 'phone', t('cal.call.ring')); g.type = 'button'; g.onclick = () => { close(); ringMeeting(m); }; acts.append(g); }
    if (m.place.kind === 'room' && live && !inIt) { const g = el('button', 'b main'); label(g, 'door', t('cal.card.go')); g.type = 'button'; g.onclick = () => { close(); goTo(m); }; acts.append(g); }
    if (m.mine && !m.owner && live) {
      for (const [ans, a] of Object.entries(RSVP)) {
        const b = el('button', 'b' + (m.rsvp === ans ? ' main' : '')); label(b, a.icon, t(m.count > 1 ? a.every : a.text)); b.type = 'button';
        b.onclick = async () => { b.disabled = true; const j = await api(`/api/cal/meetings/${m.id}`, { op: 'rsvp', answer: ans }); b.disabled = false; if (!j.ok) { err.textContent = whyOf(j); return; } showOne({ ...j.meeting, occ: m.occ }, s); refreshNext(); };
        acts.append(b);
      }
    }
    if (m.mine) { const d = el('a', 'b'); label(d, 'download', t('cal.one.ics')); d.href = `/api/cal/meetings/${m.id}/ics?lang=${encodeURIComponent(lang)}`; d.download = `${m.title}.ics`; d.title = t('cal.one.icsTitle'); d.style.textDecoration = 'none'; acts.append(d); }
    if (m.owner && m.count === 1 && live && m.place.kind === 'room') {
      const gl = el('button', 'b'); label(gl, 'people', t(m.guest ? 'cal.guestLink.renew' : 'cal.guestLink.make')); gl.type = 'button';
      gl.title = t('cal.guestLink.makeTitle');
      gl.onclick = async () => { if (m.guest && !confirm(t('cal.guestLink.renewConfirm'))) return; gl.disabled = true; const g = await api(`/api/cal/meetings/${m.id}`, { op: 'guest', make: 'new' }); gl.disabled = false; if (!g.ok) { err.textContent = whyOf(g); return; } showGuestLink(g.meeting, g.link); };
      acts.append(gl);
      if (m.guest) {
        const go = el('button', 'b warn', t('cal.guestLink.off')); go.type = 'button';
        go.onclick = async () => { if (!confirm(t('cal.guestLink.offConfirm'))) return; const g = await api(`/api/cal/meetings/${m.id}`, { op: 'guest', make: 'off' }); if (!g.ok) { err.textContent = whyOf(g); return; } o.toast(t('cal.guestLink.offDone')); showOne({ ...g.meeting, occ: m.occ }, s); };
        acts.append(go);
      }
    }
    if (m.owner) {
      const ed = el('button', 'b'); label(ed, 'pencil', t('cal.one.edit')); ed.type = 'button'; ed.onclick = () => showForm(m); acts.append(ed);
      if (m.count > 1 && live) {
        const one1 = el('button', 'b warn', t('cal.one.cancelOne')); one1.type = 'button';
        one1.onclick = async () => { if (!confirm(t('cal.one.cancelOneConfirm', { day: dayName(s) }))) return; const j = await api(`/api/cal/meetings/${m.id}`, { op: 'cancel', occ: s }); if (!j.ok) { err.textContent = whyOf(j); return; } o.toast(t('cal.one.cancelOneDone')); refreshNext(); showCal(); };
        acts.append(one1);
      }
      const all = el('button', 'b warn', t(m.count > 1 ? 'cal.one.cancelAll' : 'cal.one.cancel')); all.type = 'button';
      all.onclick = async () => { if (!confirm(t('cal.one.cancelConfirm', { title: m.title, weekly: m.count > 1 ? 'yes' : 'no' }))) return; const j = await api(`/api/cal/meetings/${m.id}`, { op: 'cancel' }); if (!j.ok) { err.textContent = whyOf(j); return; } o.toast(t('cal.one.cancelDone')); refreshNext(); showCal(); };
      acts.append(all);
    }
    one.append(acts, err);
  }

  // ---- 订阅: a secret link for calendar apps (Google, Apple, Outlook) with my meetings; shown once when made (the
  // office keeps only its hash), 重新生成 replaces it, 关闭 turns it off
  function feedBox(box) {
    const note = el('p', 'note', t('cal.feed.note'));
    const st = el('p', 'note'), made = el('div'), row = el('div', 'row'), err = el('p', 'err');
    const mk = el('button', 'b main'), off = el('button', 'b warn', t('cal.feed.off')); mk.type = off.type = 'button';
    row.append(mk, off); const own = el('div', 'calset'); own.append(note, st, row, made, err); box.append(own);
    const paint = (j) => { const on = !!j?.on; st.textContent = on ? t('cal.feed.on', { date: new Date(j.made).toLocaleDateString(lang) }) : t('cal.feed.none'); label(mk, 'download', t(on ? 'cal.feed.renew' : 'cal.feed.make')); off.style.display = on ? '' : 'none'; };
    mk.disabled = true;
    // (a failed read must not look like 「no link」: 生成 would replace a link someone uses)
    api('/api/cal/feed').then((j) => { if (j.ok) { paint(j); mk.disabled = false; } else { st.textContent = t('cal.feed.unread'); off.style.display = 'none'; label(mk, 'download', t('cal.feed.make')); } });
    mk.onclick = async () => {
      mk.disabled = true; err.textContent = '';
      const j = await api('/api/cal/feed', { op: 'new' }); mk.disabled = false;
      if (!j.ok) { err.textContent = whyOf(j); return; }
      const url = `${location.origin}${j.path}?lang=${encodeURIComponent(lang)}`, inp = el('input'); inp.type = 'text'; inp.readOnly = true; inp.value = url;
      const cp = el('button', 'b', t('cal.copy')); cp.type = 'button';
      cp.onclick = async () => { try { await navigator.clipboard.writeText(url); } catch { inp.select(); document.execCommand?.('copy'); } cp.textContent = t('cal.copied'); };
      const r = el('div', 'row'); r.append(inp, cp); inp.style.flex = '1';
      // webcal: opens the system calendar on Apple devices (and Outlook on Windows); elsewhere it does nothing
      if (/Mac|iPhone|iPad|Win/.test(navigator.platform || navigator.userAgent)) { const apple = el('a', 'b', t('cal.feed.openSystem')); apple.href = url.replace(/^https?:/, 'webcal:'); r.append(apple); }
      made.replaceChildren(r, el('p', 'note', t('cal.feed.help')));
      inp.select(); paint({ on: true, made: Date.now() });
    };
    off.onclick = async () => { if (!confirm(t('cal.feed.offConfirm'))) return; const j = await api('/api/cal/feed', { op: 'off' }); if (!j.ok) { err.textContent = whyOf(j); return; } made.replaceChildren(); paint({ on: false }); };
  }
  function showFeed() {
    shell(); dlg.dataset.view = 'feed';
    const h = head(t('cal.feed.title'), 'download', () => showCal()); h.append(el('span', 'sp'), xBtn());
    const f = el('div', 'form'), bd = el('div', 'bd'); bd.append(f);
    cc().replaceChildren(h, bd); dmBox(f); feedBox(f);
  }
  /** Raft 私信提醒: an invite and the 10-minute reminder as a Raft DM from the Deck app too (on unless turned off). */
  function dmBox(box) {
    const ck = el('input'); ck.type = 'checkbox'; ck.disabled = true;
    const row = el('label', 'ck calset'); row.style.cssText = 'display:flex;gap:6px;align-items:center;font-size:13px;cursor:pointer';
    row.append(ck, el('span', '', t('cal.dm.toggle')));
    box.append(row);
    api('/api/cal/prefs').then((j) => { if (j.ok) { ck.checked = !!j.dm; ck.disabled = false; } });
    ck.onchange = async () => { ck.disabled = true; const j = await api('/api/cal/prefs', { dm: ck.checked }); ck.disabled = false; if (!j.ok) { ck.checked = !ck.checked; o.toast(whyOf(j)); } };
  }
  o.addSettingsSection?.({ id: 'calendar', title: () => t('cal.settings.title'), icon: 'timer', order: 27, render(box) { dmBox(box); feedBox(box); } });

  /** A meeting's guest link, shown once (the office keeps only its hash). */
  function showGuestLink(m, link) {
    shell(); dlg.dataset.view = 'guest';
    const h = head(t('cal.guestLink.title'), 'people', () => showCal()); h.append(el('span', 'sp'), xBtn());
    const f = el('div', 'form'), bd = el('div', 'bd'); bd.append(f);
    cc().replaceChildren(h, bd);
    const url = location.origin + link, inp = el('input'); inp.type = 'text'; inp.readOnly = true; inp.value = url; inp.style.flex = '1';
    const cp = el('button', 'b main', t('cal.copy')); cp.type = 'button';
    cp.onclick = async () => { try { await navigator.clipboard.writeText(url); } catch { inp.select(); document.execCommand?.('copy'); } cp.textContent = t('cal.copied'); };
    const r = el('div', 'row'); r.append(inp, cp);
    f.append(el('h2', '', m.title), el('p', 'note', m.guest ? t('cal.guestLink.howUntil', { when: `${dayName(m.guest.exp)} ${hm(m.guest.exp)}` }) : t('cal.guestLink.how')), r,
      el('p', 'note', t('cal.guestLink.once')));
    inp.select();
  }

  // ---- booking and changing
  async function loadPicks() {
    const [r, p] = await Promise.all([rooms ? { ok: true, rooms } : api('/api/cal/rooms'), api('/api/cal/people')]);
    if (r.ok) rooms = r.rooms;
    // the people who have been aboard, and anyone online on this floor right now
    const seen = new Map();
    for (const x of p.ok ? p.people : []) seen.set(x.login, x);
    for (const q of o.peers().values()) if (q.sub && !q.guest && !q.visitor && !String(q.sub).startsWith('guest:') && !seen.has(q.sub)) seen.set(q.sub, { login: q.sub, name: q.name, kind: q.kind === 'agent' ? 'agent' : 'human' });
    const me = o.me(); if (me?.sub) seen.delete(me.sub);
    people = [...seen.values()];
  }
  async function showForm(m, at, room) {
    shell(); dlg.dataset.view = 'form';
    const h = head(t(m ? 'cal.form.editTitle' : 'cal.book'), 'pencil', () => showCal()); h.append(el('span', 'sp'), xBtn());
    const f = el('div', 'form'), bd = el('div', 'bd'); bd.append(f);
    cc().replaceChildren(h, bd);
    f.append(el('div', 'empty', t('cal.form.loading')));
    await loadPicks();
    if (!dlg || dlg.dataset.view !== 'form') return;
    f.replaceChildren();
    // when: the next half hour by default (or where the grid was double-clicked)
    let t0 = m ? m.start : at ?? Math.ceil((Date.now() + 5 * MIN) / (30 * MIN)) * 30 * MIN;
    const title = el('input'); title.type = 'text'; title.maxLength = 60; title.placeholder = t('cal.form.titleHint'); title.value = m?.title ?? '';
    const date = el('input'); date.type = 'date';
    const time = el('input'); time.type = 'time'; time.step = 300;
    const d0 = new Date(t0); date.value = `${d0.getFullYear()}-${pad(d0.getMonth() + 1)}-${pad(d0.getDate())}`; time.value = `${pad(d0.getHours())}:${pad(d0.getMinutes())}`;
    let dur = m?.dur ?? 30;
    const durs = [15, 30, 45, 60, 90, 120, 180].concat(m && ![15, 30, 45, 60, 90, 120, 180].includes(m.dur) ? [m.dur] : []).sort((a, b) => a - b);
    const durDd = dropdown({ label: t('cal.form.dur'), className: 'dd-field', value: dur, options: durs.map((v) => ({ value: v, text: durText(v) })), onChange: (v) => { dur = v; } });
    durDd.el.style.width = '140px';
    // where: a 会议室 on any floor (this floor's first), or 通话 when the page can make calls
    const here = o.floor?.id ?? 1;
    const opts = (rooms ?? []).slice().sort((a, b) => (a.floor === here ? -1 : 0) - (b.floor === here ? -1 : 0) || a.floor - b.floor)
      .map((r) => ({ value: `${r.floor}:${r.zone}`, text: `${boatOf(r)} · ${r.name}`, icon: 'door' }));
    if (o.call || m?.place.kind === 'call') opts.push({ value: 'call', text: t('cal.form.placeCall'), icon: 'people' });
    let where = m ? (m.place.kind === 'call' ? 'call' : `${m.place.floor}:${m.place.zone}`) : (opts.find((x) => x.value === (room ?? `${here}:${o.room?.()}`))?.value ?? opts[0]?.value ?? null);
    const placeDd = opts.length ? dropdown({ label: t('cal.where'), className: 'dd-field', value: where, options: opts, onChange: (v) => { where = v; } }) : null;
    let count = m?.count ?? 1;
    const weekly = el('input'); weekly.type = 'checkbox'; weekly.checked = count > 1;
    const times = el('input'); times.type = 'number'; times.min = '2'; times.max = '52'; times.value = String(count > 1 ? count : 8); times.style.width = '70px'; times.disabled = !weekly.checked;
    weekly.onchange = () => { times.disabled = !weekly.checked; };
    const agenda = el('textarea'); agenda.maxLength = 2000; agenda.placeholder = t('cal.form.agendaHint'); agenda.value = m?.agenda ?? '';
    const rec = el('input'); rec.type = 'checkbox'; rec.checked = !!m?.record;
    const chosen = new Map((m?.invitees ?? []).map((i) => [i.login, i]));
    const chips = el('div', 'chips'), q = el('input'), who = el('div', 'who');
    q.type = 'text'; q.placeholder = t('cal.form.whoHint');
    function paintChips() {
      chips.replaceChildren(...[...chosen.values()].map((i) => { const c = el('span', 'chip', t('cal.form.chip', { name: i.name, agent: i.kind === 'agent' ? 'yes' : 'no' })); const x = el('button'); x.type = 'button'; x.title = t('cal.form.uninvite'); x.append(icon('close')); x.onclick = () => { chosen.delete(i.login); paintChips(); paintWho(); }; c.append(x); return c; }));
      if (!chosen.size) chips.append(el('span', 'note', t('cal.form.noneChosen')));
    }
    function paintWho() {
      const s = q.value.trim().toLowerCase(), list = (people ?? []).filter((p) => !s || p.name.toLowerCase().includes(s));
      who.replaceChildren();
      if (!list.length) { who.append(el('div', 'none', t(people?.length ? 'cal.form.noMatch' : 'cal.form.noPeople'))); return; }
      for (const p of list.slice(0, 100)) {
        const row = el('label', 'p'), c = el('input'); c.type = 'checkbox'; c.checked = chosen.has(p.login);
        c.onchange = () => { if (c.checked) chosen.set(p.login, p); else chosen.delete(p.login); paintChips(); };
        row.append(c, el('span', '', p.name)); if (p.kind === 'agent') row.append(icon('robot'));
        who.append(row);
      }
    }
    q.oninput = paintWho;
    paintChips(); paintWho();
    const r1 = el('div', 'row'); r1.append(date, time, durDd.el);
    const r2 = el('label', 'ck'); r2.append(weekly, ...tParts('cal.form.weekly', { times }).map((x) => (typeof x === 'string' ? el('span', '', x) : x)));
    const r3 = el('label', 'ck'); r3.append(rec, el('span', '', t('cal.form.record')));
    // 访客链接 (a new meeting, once, within 7 days): made right after booking, shown once
    const gst = el('input'); gst.type = 'checkbox';
    const r4 = el('label', 'ck'); r4.append(gst, el('span', '', t('cal.form.guestLink')));
    if (m) r4.style.display = 'none';
    weekly.addEventListener('change', () => { gst.disabled = weekly.checked; if (weekly.checked) gst.checked = false; });
    f.append(el('label', 'f', t('cal.form.name')), title, el('label', 'f', t('cal.form.when', { tz: TZ })), r1, r2, el('label', 'f', t('cal.where')), placeDd ? placeDd.el : el('p', 'note', t('cal.form.noRooms')),
      el('label', 'f', t('cal.form.invite')), chips, q, who, el('label', 'f', t('cal.agenda')), agenda, r3, r4);
    const err = el('p', 'err'), save = el('button', 'b main'); label(save, 'check', t(m ? 'cal.form.save' : 'cal.form.book')); save.type = 'button';
    const acts = el('div', 'row'); acts.style.marginTop = '14px'; acts.append(save);
    f.append(acts, err);
    if (!m) title.focus();
    save.onclick = async () => {
      err.textContent = '';
      const [y, mo, d] = date.value.split('-').map(Number), [hh, mi] = time.value.split(':').map(Number);
      if (!y || hh == null || Number.isNaN(hh)) { err.textContent = t('cal.form.needWhen'); return; }
      const start = new Date(y, mo - 1, d, hh, mi || 0).getTime();
      if (!title.value.trim()) { err.textContent = t('cal.err.E_INVALID.title'); title.focus(); return; }
      if (!where) { err.textContent = t('cal.form.needPlace'); return; }
      const place = where === 'call' ? { kind: 'call' } : { kind: 'room', floor: Number(where.split(':')[0]), zone: where.slice(where.indexOf(':') + 1) };
      const n = weekly.checked ? Math.max(2, Math.min(52, Math.round(Number(times.value) || 2))) : 1;
      const body = { title: title.value.trim(), start, dur, tz: TZ, count: n, place, invitees: [...chosen.keys()], agenda: agenda.value, record: rec.checked };
      if (m) { // an edit sends what changed: the zone only with a new time (else the series keeps its own), the room and the invitees only if changed
        if (start === m.start) { delete body.start; delete body.tz; }
        if (where === (m.place.kind === 'call' ? 'call' : `${m.place.floor}:${m.place.zone}`)) delete body.place;
        const was = (m.invitees ?? []).map((i) => i.login).sort().join(), now = [...chosen.keys()].sort().join();
        if (was === now) delete body.invitees;
      }
      save.disabled = true;
      const j = await api(m ? `/api/cal/meetings/${m.id}` : '/api/cal/meetings', m ? { op: 'edit', ...body } : body);
      save.disabled = false;
      if (!j.ok) { err.textContent = whyOf(j); return; }
      o.toast(t(m ? 'cal.form.saved' : chosen.size ? 'cal.form.bookedTold' : 'cal.form.booked'), null, 'check');
      anchor = start; refreshNext();
      if (!m && gst.checked && where !== 'call') { const g = await api(`/api/cal/meetings/${j.meeting.id}`, { op: 'guest', make: 'new' }); if (g.ok) { showGuestLink(g.meeting, g.link); return; } o.toast(t('cal.guestLink.failed', { why: whyOf(g) })); }
      showCal();
    };
  }

  // ---- going there: walk to the room on this floor, or go to its floor first (the page reloads there; the walk is
  // kept in sessionStorage for the new page)
  const goTo = (m) => goToRoom(o, m.place, m.record ? { title: m.title, until: (m.occ?.find((s) => s + m.dur * MIN > Date.now()) ?? m.start) + m.dur * MIN } : null);

  // ---- 会议纪要 at the start of a meeting booked with it: offered to whoever is in its room (never started by itself)
  const recWant = new Map(); // zone -> {title, until}
  function offerRecord(zone) {
    const w = recWant.get(zone);
    if (!w || w.until < Date.now() || o.room?.() !== zone || !o.notes?.supported?.() || !o.notes.canStart() || o.notes.live(zone) || w.offered) return;
    w.offered = true;
    o.toast(t('cal.rec.offer', { title: w.title }), () => { if (o.room?.() === zone && !o.notes.live(zone)) o.notes.toggle(); }, 'note', t('cal.rec.start'));
  }

  // ---- what the office tells me
  function card(m, op, occ) {
    const s = occ ?? m.start, room = m.place.kind === 'room', key = `cal:${m.id}:${op}:${s}`;
    if (op === 'invite') {
      o.members.addCard({ id: key, icon: 'timer', text: t('cal.card.invite', { name: m.by.name, title: m.title, when: `${dayName(s)} ${hm(s)}`, place: placeText(m.place) }), quiet: !!o.dnd?.(), expires: Date.now() + 10 * MIN,
        yes: t('cal.card.view'), yesIcon: 'note', yesTitle: t('cal.card.viewTitle'), no: t(m.count > 1 ? 'cal.card.declineAll' : 'cal.rsvp.no'), noIcon: 'close', left: () => t('cal.card.newInvite'),
        accept: () => showOne(m, s), decline: () => api(`/api/cal/meetings/${m.id}`, { op: 'rsvp', answer: 'no' }).then((j) => { if (j.ok) o.toast(t('cal.card.declined')); refreshNext(); }) });
      return;
    }
    const soon = op === 'soon', end = s + m.dur * MIN;
    if (m.place.kind === 'call') return callCard(m, op, s, key);
    for (const k of soon ? ['invite'] : ['invite', 'soon']) o.members.dropCard(`cal:${m.id}:${k}:${s}`);
    // already in that room: nothing to walk to
    const go = room && !(m.place.floor === (o.floor?.id ?? 1) && o.room?.() === m.place.zone);
    o.members.addCard({ id: key, prio: 1, quiet: !!o.dnd?.(), icon: 'timer', text: t(soon ? 'cal.card.soon' : 'cal.card.now', { title: m.title, place: placeText(m.place) }),
      expires: soon ? s : Math.min(end, s + 15 * MIN),
      yes: t(go ? 'cal.card.go' : 'cal.card.ok'), yesIcon: go ? 'door' : 'check', yesTitle: go ? t('cal.card.goFloorTitle') : '', no: t(go ? 'cal.card.ok' : 'cal.card.close'), noIcon: 'close',
      left: (ms) => (soon ? t('cal.card.inMin', { n: Math.max(1, Math.ceil(ms / MIN)) }) : t('cal.card.on')),
      accept: () => { if (go) goTo(m); }, decline: () => {} });
    if (!soon && m.record && room && m.place.floor === (o.floor?.id ?? 1)) { recWant.set(m.place.zone, { title: m.title, until: end }); offerRecord(m.place.zone); }
  }
  /** A booked 通话's reminder: 发起通话 rings the people in it who are on this floor now (anyone in it may: the first to
   *  press rings the others; in a call already, it adds them). People on other floors join when they're rung there, or
   *  ring from their own floor. */
  function callCard(m, op, s, key) {
    const soon = op === 'soon', end = s + m.dur * MIN;
    for (const k of soon ? ['invite'] : ['invite', 'soon']) o.members.dropCard(`cal:${m.id}:${k}:${s}`);
    o.members.addCard({ id: key, prio: 1, quiet: !!o.dnd?.(), icon: 'phone', text: t(soon ? 'cal.card.soon' : 'cal.card.now', { title: m.title, place: t('cal.place.call') }),
      expires: soon ? s : Math.min(end, s + 15 * MIN), anytime: true,
      yes: t('cal.call.ring'), yesIcon: 'phone', yesTitle: t('cal.call.ringTitle'), no: t('cal.card.ok'), noIcon: 'close',
      left: (ms) => (soon ? t('cal.card.inMin', { n: Math.max(1, Math.ceil(ms / MIN)) }) : t('cal.card.on')),
      accept: () => ringMeeting(m), decline: () => {} });
  }
  function ringMeeting(m) {
    if (!o.call) return;
    const logins = new Set([m.by.login, ...(m.invitees ?? []).map((i) => i.login)]), me = o.me();
    const ids = [...o.peers().values()].filter((p) => p.sub && logins.has(p.sub) && p.id !== me?.id && !(o.call.active()?.members ?? []).some((x) => x.here && x.peer === p.id)).map((p) => p.id);
    if (!ids.length) { o.toast(t('cal.call.nobody')); return; }
    o.call.ring(ids.slice(0, 8));
  }
  // the language changed (设置 → 语言): the button's next meeting, the plaques, and an open calendar, meeting or
  // 订阅 view draw again (a half-filled form or a guest link shown once stay as they are until they're left)
  onLang(() => {
    paintNext(); tagsAt = 0;
    if (!dlg) return;
    dlg.setAttribute('aria-label', t('cal.title'));
    const v = dlg.dataset.view;
    if (v === 'cal') showCal(); else if (v === 'feed') showFeed(); else if (v === 'one' && shownOne) showOne(...shownOne);
  });
  return {
    welcome() { refreshNext(); refreshToday(); pendingGo(o, (z, w) => recWant.set(z, w)); },
    /** meeting.js: I walked into a 会议室. */
    entered(zone) { offerRecord(zone); },
    msg(m) {
      if (m.t !== 'cal' || !m.m || typeof m.m !== 'object') return;
      const mt = m.m;
      if (m.op === 'invite' || m.op === 'soon' || m.op === 'now') card(mt, m.op, m.occ ?? null);
      else if (m.op === 'cancelled') {
        o.toast(m.occ ? t('cal.msg.cancelledOne', { title: mt.title, day: dayName(m.occ) }) : t('cal.msg.cancelled', { title: mt.title }), null, 'timer');
        for (const c of o.members.list()) if (c.id.startsWith(`cal:${mt.id}:`) && (!m.occ || c.id.endsWith(`:${m.occ}`))) o.members.dropCard(c.id);
      }
      else if (m.op === 'changed' && !mt.owner) o.toast(t('cal.msg.changed', { title: mt.title }), () => { anchor = mt.start; showCal(); }, 'timer', t('cal.card.view'));
      refreshNext(); refreshToday();
      if (dlg?.dataset.view === 'cal') showCal();
    },
    roomSchedule, roomTag,
  };
}
